export const RETURN_AND_EXCHANGE_SLUG = 'return_policy';

export enum USER_TYPE {
  DOMESTIC,
  INTERNATIONAL,
}

export const VISIT_STORE_ANCHOR_WIDTH = 84;
